<template>
  <div>
    <notifications group="notify"/>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  async mounted(){
    // Load the language terms
    let data = localStorage.getItem("selected_langauge")

    if(data)
    {
      await this.loadLanguageTerms(data)
    }
    else
    {
      await this.loadLanguageTerms('en')
    }

  },
  computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
  },
  watch:{
    async selected_lang(newVal) {
      await this.loadLanguageTerms(newVal)
    }
  },
  methods:{
      async loadLanguageTerms(selected_language){
      await this.$store.dispatch("languages/fetchAll", {"language_code": selected_language})
    }
  }
}
</script>
<style>
.container-padding{
  padding-bottom:70px;
}
/* Large devices (laptops/desktops, 992px and up) */ 
@media only screen and (min-width: 1200px){
  .floating-bar {
    margin:auto;
    /* background: rgba(233, 239, 239, 0.9); */
    background: rgba(41, 47, 76, 0.8);
    color:white;
    position: fixed;
    width:30%;
    left: 0;
    right: 0;
    bottom: 20px;
    height: 60px;
    border-radius: 10px;
  }  

  .floating-bar-container{
    margin-top:8px !important;
  }
}
/* IPAD devices */ 

@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (-webkit-min-device-pixel-ratio: 1) {
  .floating-bar {
    margin:auto;
    /* background: rgba(233, 239, 239, 0.9); */
    background: rgba(41, 47, 76, 0.8);
    /* display:flex; */
    color:white;
    position: fixed;
    width:80%;
    left: 0;
    right: 0;
    bottom: 20px;
    height: 60px;
    border-radius: 10px;
  }  

  .floating-bar-container{
    margin-top:8px !important;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
.floating-bar {
    /* margin:auto; */
    /* background: rgba(233, 239, 239, 0.9); */
    background: rgba(41, 47, 76, 0.8);
    /* display:flex; */
    color:white;
    position: fixed;
    /* width:30%; */
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
  }  

  .floating-bar-container{
    margin-top:8px !important;
  }
}

  .transparent-btn{
    background-color: transparent;
    border-color: transparent;
    color:white;
  }
  .transparent-btn:hover{
    color:#007bff;
    background-color: #fff;
  }
    .my-modal .modal-body
    {
        max-height: 80vh; /* max 80% of the viewport height */
        overflow-y: auto;
    }
  .float
  {
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	right:40px;
	/* background-color:#0C9; */
  background-color:#2dce89;
	color:#FFF;
	border-radius:50px;
	text-align:center;
	box-shadow: 2px 2px 3px #999;
}

.my-float{
	margin-top:22px;
}
.bg-default {
    /* background-color: #172b4d !important; */
    background-color: #fff !important;
}

.navbar-top {
    height: 50px;
}

.navbar-vertical.navbar-expand-xs .navbar-nav > .nav-item > .nav-link.active {
    background: #f6f9fc;
    /* margin-right: .5rem;
    margin-left: .5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem; */
    color: black;
}

.sidenav-toggler-line {
    background-color: #fff;
}

  
.sidenav-toggler-line {
    background-color: #e9a566;
}

 .float-button
  {
    position:fixed;
    width:60px;
    height:60px;
    bottom:40px;
    right:40px;
    /* background-color:#0C9; */
    background-color:#2dce89;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px #999;
  }
.my-float-button{
	/* margin-top:20px; */
  margin-top:22px;
}

ul.timeline {
    list-style-type: none;
    position: relative;
}
ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
ul.timeline > li {
    margin: 20px 0;
    padding-left: 20px;
}
/* ul.timeline > li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #22c0e8;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
} */
ul.timeline > li.statusopen:before{
      content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #22c0e8;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}

ul.timeline > li.statuspendingapproval:before{
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #ffc107;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}

ul.timeline > li.statusapproved:before{
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #2dce89;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}

ul.timeline > li.statusrejected:before{
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid red;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}

ul.timeline > li.statusrevised:before{
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #5603ad;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}


</style>
